import { Component, Input } from "@angular/core";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { CustomModal } from "../../../../../core/components/base-modals";

@Component({
	selector: "wallet-selection-modal",
	templateUrl: "./wallet-selection-modal.html",
	styleUrls: ["./wallet-selection-modal.scss"],
	standalone: false
})
export class WalletSelectionModalComponent extends CustomModal {
	@Input() public tradableWallets: TradableWallet[] = [];
	@Input() public tradableId: string = "";

	public onClick(tradableWallet: TradableWallet): void {
		this.modalService.getCurrentModal().dismiss(tradableWallet);
	}

	public getTradables(): TradableWallet[] {
		return this.tradableWallets;
	}
}
